import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useSWR from 'swr'

import { DocumentDetail } from '@/components/DocumentDetail/DocumentDetail'
import { Loading } from '@/components/Loading'
import { useSetPageHeader } from '@/contexts/PageHeaderContext'
import { apiFetcher } from '@/data/fetcher'

export default function OrderDetailPage() {
  const { id } = useParams()
  const { t } = useTranslation(undefined, {
    keyPrefix: 'order',
  })

  const { data: documentData, isLoading: ordersLoading } = useSWR(
    id && `/api/v2/orders/${id}`,
    apiFetcher,
  )
  const title = `${t('edit.title')} ${id}`

  useSetPageHeader({
    breadcrumbs: [
      {
        href: '/orders',
        children: t('list.title'),
      },
      {
        href: `/order/${id}`,
        children: id as string,
      },
    ],
  })

  return (
    <>
      <title>{title}</title>

      {ordersLoading && <Loading />}

      {documentData && <DocumentDetail document={documentData} linkSegment="order" />}
    </>
  )
}
